/**
 * CocktailBox — Cart Drawer (slide-out sidebar)
 */

(function () {
  'use strict';

  var drawer = document.getElementById('cb-cart-drawer');
  var overlay = document.getElementById('cb-cart-drawer-overlay');
  var closeBtn = document.getElementById('cb-cart-drawer-close');
  var body = document.getElementById('cb-cart-drawer-body');
  var itemsContainer = document.getElementById('cb-cart-drawer-items');
  var emptyState = document.getElementById('cb-cart-drawer-empty');
  var footer = document.getElementById('cb-cart-drawer-footer');
  var totalEl = document.getElementById('cb-cart-drawer-total');

  if (!drawer) return;

  // =========================================================================
  // Open / Close
  // =========================================================================

  // Focus moves into the drawer on open, Tab stays inside it, and focus
  // returns to the element that opened it on close (modal dialog pattern)
  var lastFocus = null;
  var panel = drawer.querySelector('.cb-cart-drawer__panel');

  function focusables() {
    return Array.prototype.filter.call(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cb-cart-drawer-open');
    fetchCart();
    setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 50);
  }

  function close() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cb-cart-drawer-open');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }

  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var items = focusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  overlay.addEventListener('click', close);
  closeBtn.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      close();
    }
  });

  // =========================================================================
  // Fetch Cart
  // =========================================================================

  function fetchCart() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        return cart;
      })
      .catch(function (err) {
        console.error('Cart fetch error:', err);
      });
  }

  // =========================================================================
  // Render Cart
  // =========================================================================

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = window.cbMoneyFormat || '{{amount}} EUR';
    return fmt
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'))
      .replace('{{amount_with_apostrophe_separator}}', amount.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'"))
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount}}', amount);
  }

  var lastCart = null;

  function renderCart(cart) {
    lastCart = cart;
    if (cart.item_count === 0) {
      emptyState.classList.remove('hidden');
      itemsContainer.innerHTML = '';
      footer.classList.add('hidden');
      if (deliveryCard) deliveryCard.classList.add('hidden');
      return;
    }

    emptyState.classList.add('hidden');
    footer.classList.remove('hidden');
    if (deliveryCard) deliveryCard.classList.remove('hidden');
    totalEl.textContent = formatMoney(cart.total_price);

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image
        ? item.image.replace(/(\.\w+)(\?|$)/, '_200x200$1$2')
        : '';
      var variantTitle = item.variant_title || '';

      html += '<div class="cb-cart-drawer__item" data-key="' + item.key + '">';
      html += '  <div class="cb-cart-drawer__item-image">';
      if (imgSrc) {
        html += '    <img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">';
      }
      html += '  </div>';
      html += '  <div class="cb-cart-drawer__item-details">';
      html += '    <p class="cb-cart-drawer__item-title">' + escapeHtml(item.product_title) + '</p>';
      if (variantTitle && variantTitle !== 'Default Title') {
        html += '    <p class="cb-cart-drawer__item-variant">' + escapeHtml(variantTitle) + '</p>';
      }
      html += '    <p class="cb-cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>';
      html += '    <div class="cb-cart-drawer__item-actions">';
      html += '      <div class="cb-cart-drawer__quantity">';
      html += '        <button class="cb-cart-drawer__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Намали количеството"' + (item.quantity <= 1 ? ' disabled' : '') + '>−</button>';
      html += '        <span class="cb-cart-drawer__qty-value" aria-label="Количество ' + item.quantity + '">' + item.quantity + '</span>';
      html += '        <button class="cb-cart-drawer__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Увеличи количеството">+</button>';
      html += '      </div>';
      html += '      <button class="cb-cart-drawer__remove" data-key="' + item.key + '" aria-label="Премахни ' + escapeHtml(item.product_title) + '">';
      html += '        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M3 6H5H21M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      html += '      </button>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';
    });

    itemsContainer.innerHTML = html;
    bindItemActions();
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // =========================================================================
  // Item Actions (quantity + remove)
  // =========================================================================

  function bindItemActions() {
    var qtyBtns = itemsContainer.querySelectorAll('.cb-cart-drawer__qty-btn');
    var removeBtns = itemsContainer.querySelectorAll('.cb-cart-drawer__remove');

    qtyBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var action = btn.getAttribute('data-action');
        var item = btn.closest('.cb-cart-drawer__item');
        var current = parseInt(item.querySelector('.cb-cart-drawer__qty-value').textContent, 10);
        var newQty = action === 'increase' ? current + 1 : current - 1;
        if (newQty < 1) newQty = 1;
        updateQuantity(key, newQty, item);
      });
    });

    removeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var item = btn.closest('.cb-cart-drawer__item');
        updateQuantity(key, 0, item);
      });
    });
  }

  function updateQuantity(key, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-loading');

    // Check if we're removing a cocktail mix item (before the request)
    var removingCocktailMix = false;
    if (quantity === 0 && lastCart) {
      lastCart.items.forEach(function (item) {
        if (item.key === key && item.properties && item.properties._cocktail_mix) {
          removingCocktailMix = true;
        }
      });
    }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (removingCocktailMix) {
          // Check if any other cocktail mix items remain
          var hasCocktailMix = cart.items.some(function (item) {
            return item.properties && item.properties._cocktail_mix;
          });
          if (!hasCocktailMix) {
            // Remove all upsell items
            var upsellKeys = [];
            cart.items.forEach(function (item) {
              if (item.properties && item.properties._upsell_for) {
                upsellKeys.push(item.key);
              }
            });
            if (upsellKeys.length > 0) {
              removeUpsellItems(upsellKeys);
              return;
            }
          }
        }
        renderCart(cart);
        if (window.cbCartBadge) window.cbCartBadge.update(cart.item_count);
      })
      .catch(function (err) {
        console.error('Cart update error:', err);
        if (itemEl) itemEl.classList.remove('is-loading');
      });
  }

  function removeUpsellItems(keys) {
    if (keys.length === 0) {
      return fetchCart().then(function (cart) {
        if (cart && window.cbCartBadge) window.cbCartBadge.update(cart.item_count);
      });
    }
    var key = keys.shift();
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return removeUpsellItems(keys);
      });
  }

  // =========================================================================
  // Delivery Date Calendar
  // =========================================================================

  var deliveryCard = document.getElementById('cb-cart-drawer-delivery');
  var deliveryToggle = document.getElementById('cb-cart-drawer-delivery-toggle');
  var deliveryCalendar = document.getElementById('cb-cart-drawer-calendar');
  var deliveryLabel = document.getElementById('cb-cart-drawer-date-label');
  var deliveryTitle = document.getElementById('cb-cart-drawer-delivery-title');
  var deliveryBtn = document.getElementById('cb-cart-drawer-delivery-btn');
  var checkoutBtn = document.getElementById('cb-cart-drawer-checkout');
  var selectedDate = null;

  // Bulgarian public holidays (fixed + Orthodox Easter)
  var holidays = [
    '2026-01-01', '2026-03-03',
    '2026-04-10', '2026-04-11', '2026-04-12', '2026-04-13',
    '2026-05-01', '2026-05-06', '2026-05-24',
    '2026-09-06', '2026-09-22',
    '2026-12-24', '2026-12-25', '2026-12-26',
    '2027-01-01', '2027-03-03',
    '2027-04-30', '2027-05-01', '2027-05-02', '2027-05-03',
    '2027-05-06', '2027-05-24',
    '2027-09-06', '2027-09-22',
    '2027-12-24', '2027-12-25', '2027-12-26'
  ];

  var holidaySet = {};
  holidays.forEach(function (d) { holidaySet[d] = true; });

  function calPad(n) { return n < 10 ? '0' + n : '' + n; }

  function calToKey(date) {
    return date.getFullYear() + '-' + calPad(date.getMonth() + 1) + '-' + calPad(date.getDate());
  }

  function calIsWorkday(date) {
    if (date.getDay() === 0) return false;
    return !holidaySet[calToKey(date)];
  }

  function calAddWorkdays(start, days) {
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (calIsWorkday(d)) added++;
    }
    return d;
  }

  var bgDays = ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'];
  var bgDaysFull = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];
  var bgMonths = [
    'Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни',
    'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'
  ];

  // Calculate min/max delivery dates
  var calToday = new Date();
  calToday.setHours(0, 0, 0, 0);
  var calMinDate = calAddWorkdays(calToday, 2);
  var calMaxDate = calAddWorkdays(calToday, 14);

  function calIsAvailable(date) {
    if (!calIsWorkday(date)) return false;
    var d = new Date(date); d.setHours(0, 0, 0, 0);
    return d >= calMinDate && d <= calMaxDate;
  }

  function calSameDay(a, b) {
    return a && b &&
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();
  }

  var calCurrentMonth = calMinDate.getMonth();
  var calCurrentYear = calMinDate.getFullYear();

  function renderCalendar() {
    if (!deliveryCalendar) return;

    var year = calCurrentYear;
    var month = calCurrentMonth;
    var firstDay = new Date(year, month, 1);
    var lastDay = new Date(year, month + 1, 0);
    var startDow = firstDay.getDay();
    // Shift so Monday=0 ... Sunday=6
    var mondayStart = (startDow === 0) ? 6 : startDow - 1;

    var canPrev = new Date(year, month, 0) >= calMinDate;
    var canNext = new Date(year, month + 1, 1) <= calMaxDate;

    var html = '';

    // Nav
    html += '<div class="cb-cal-nav">';
    html += '  <button class="cb-cal-nav-btn" data-cal-nav="prev"' + (canPrev ? '' : ' disabled') + '>';
    html += '    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    html += '  </button>';
    html += '  <span class="cb-cal-month-label">' + bgMonths[month] + ' ' + year + '</span>';
    html += '  <button class="cb-cal-nav-btn" data-cal-nav="next"' + (canNext ? '' : ' disabled') + '>';
    html += '    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    html += '  </button>';
    html += '</div>';

    // Grid
    html += '<div class="cb-cal-grid">';

    // Weekday headers (Mon-Sun)
    var weekdays = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];
    weekdays.forEach(function (wd) {
      html += '<span class="cb-cal-weekday">' + wd + '</span>';
    });

    // Empty cells before first day
    for (var e = 0; e < mondayStart; e++) {
      html += '<span class="cb-cal-day cb-cal-day--empty"></span>';
    }

    // Day cells
    for (var d = 1; d <= lastDay.getDate(); d++) {
      var date = new Date(year, month, d);
      var key = calToKey(date);
      var isToday = calSameDay(date, calToday);
      var isSelected = calSameDay(date, selectedDate);
      var available = calIsAvailable(date);

      var cls = 'cb-cal-day';
      if (isToday) cls += ' cb-cal-day--today';
      if (isSelected) cls += ' cb-cal-day--selected';
      else if (available) cls += ' cb-cal-day--available';
      else cls += ' cb-cal-day--disabled';

      if (available || isSelected) {
        html += '<button class="' + cls + '" data-cal-date="' + key + '">' + d + '</button>';
      } else {
        html += '<span class="' + cls + '">' + d + '</span>';
      }
    }

    html += '</div>';

    deliveryCalendar.innerHTML = html;
    bindCalendarActions();
  }

  function bindCalendarActions() {
    if (!deliveryCalendar) return;

    // Month navigation
    deliveryCalendar.querySelectorAll('[data-cal-nav]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var dir = btn.getAttribute('data-cal-nav');
        if (dir === 'prev') {
          calCurrentMonth--;
          if (calCurrentMonth < 0) { calCurrentMonth = 11; calCurrentYear--; }
        } else {
          calCurrentMonth++;
          if (calCurrentMonth > 11) { calCurrentMonth = 0; calCurrentYear++; }
        }
        renderCalendar();
      });
    });

    // Day selection (save happens when user clicks "Запази")
    deliveryCalendar.querySelectorAll('[data-cal-date]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var key = btn.getAttribute('data-cal-date');
        var parts = key.split('-');
        selectedDate = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
        renderCalendar();
        updateDeliveryLabel();
        if (deliveryTitle) deliveryTitle.textContent = 'Избрана дата за доставка';
      });
    });
  }

  function updateDeliveryLabel() {
    if (!deliveryLabel || !selectedDate) return;
    var dd = calPad(selectedDate.getDate());
    var mm = calPad(selectedDate.getMonth() + 1);
    var dayName = bgDaysFull[selectedDate.getDay()];
    deliveryLabel.textContent = dd + '.' + mm + '.' + selectedDate.getFullYear() + ' (' + dayName + ')';
  }

  function saveDeliveryDate() {
    if (!selectedDate) return;
    var dd = calPad(selectedDate.getDate());
    var mm = calPad(selectedDate.getMonth() + 1);
    var dayName = bgDaysFull[selectedDate.getDay()];
    var dateStr = dd + '.' + mm + '.' + selectedDate.getFullYear() + ' (' + dayName + ')';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Delivery Date': dateStr } }),
      credentials: 'same-origin'
    }).catch(function (err) {
      console.error('Failed to save delivery date:', err);
    });
  }

  // Helper: format date for label
  function fmtDateShort(d) {
    return calPad(d.getDate()) + '.' + calPad(d.getMonth() + 1) + ' (' + bgDaysFull[d.getDay()] + ')';
  }

  function setDeliveryExpanded(expanded) {
    if (!deliveryCard) return;
    deliveryCard.setAttribute('data-expanded', expanded ? 'true' : 'false');
    // aria-expanded belongs on the control, not on the container (W3C)
    if (deliveryToggle) deliveryToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (deliveryBtn) deliveryBtn.textContent = expanded ? 'Запази' : 'Промени';
    if (checkoutBtn) {
      // A submit button since the delivery picker: disabled for real while the calendar is open
      checkoutBtn.disabled = expanded;
      if (expanded) {
        checkoutBtn.classList.add('is-disabled');
      } else {
        checkoutBtn.classList.remove('is-disabled');
      }
    }
    if (expanded) renderCalendar();
  }

  // Expand/collapse delivery card
  if (deliveryToggle && deliveryCard) {
    // Click on the header row (icon + text) → toggle
    deliveryToggle.addEventListener('click', function (e) {
      // Don't toggle if the button itself was clicked (handled separately)
      if (e.target.closest('#cb-cart-drawer-delivery-btn')) return;
      var expanded = deliveryCard.getAttribute('data-expanded') === 'true';
      setDeliveryExpanded(!expanded);
    });
    deliveryToggle.addEventListener('keydown', function (e) {
      if (e.target.closest('#cb-cart-drawer-delivery-btn')) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        deliveryToggle.click();
      }
    });
  }

  // "Промени" / "Запази" button
  if (deliveryBtn) {
    deliveryBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var expanded = deliveryCard.getAttribute('data-expanded') === 'true';
      if (expanded) {
        // "Запази" — save the selected date and close
        updateDeliveryLabel();
        saveDeliveryDate();
        if (deliveryTitle) {
          deliveryTitle.textContent = selectedDate ? 'Избрана дата за доставка' : 'Дата за доставка';
        }
        setDeliveryExpanded(false);
      } else {
        // "Промени" — open calendar
        setDeliveryExpanded(true);
      }
    });
  }

  // Set default delivery date label (2–4 workdays range)
  if (deliveryLabel && !selectedDate) {
    var defaultFrom = calAddWorkdays(calToday, 2);
    var defaultTo = calAddWorkdays(calToday, 4);
    deliveryLabel.textContent = 'по подразбиране: между ' + fmtDateShort(defaultFrom) + ' и ' + fmtDateShort(defaultTo);
  }

  // =========================================================================
  // Events
  // =========================================================================

  // Open drawer when item is added to cart
  document.addEventListener('cb:cart:added', function () {
    setTimeout(open, 150);
  });

  // Cart icon in header + notification "view cart" link → open drawer
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('a[href="/cart"], a[href$="/cart"], .cb-cart-notification__view-cart');
    if (cartLink) {
      e.preventDefault();
      // Hide notification toast if visible
      if (window.cbCartNotification) window.cbCartNotification.hide();
      open();
    }
  });

  // =========================================================================
  // Public API
  // =========================================================================

  window.cbCartDrawer = { open: open, close: close, refresh: fetchCart };
})();
